import { Authenticator } from '@aws-amplify/ui-react'
import { Amplify } from 'aws-amplify'
import React from 'react'
import ReactDOM from 'react-dom'
import singleSpaReact from 'single-spa-react'
import { awsConfig } from './api/aws-exports'
import { LoginPage } from './root.component'

Amplify.configure(awsConfig)

const AuthenticatorWrapper = () => {
  return (
    <Authenticator.Provider>
      <LoginPage />
    </Authenticator.Provider>
  )
}

const lifecycles = singleSpaReact({
  React,
  ReactDOM,
  rootComponent: AuthenticatorWrapper,
  errorBoundary() {
    return null
  },
})

export const { bootstrap, mount, unmount } = lifecycles
